export class DentalInfo {
  hasDentist: boolean;
  practiceName?: string;
  dentistName?: string;
  lastDentalCleaning?: string;
  pendingTreatment?: boolean;
  pendingTreatmentDescription?: string;
  smileSatisfaction?: SmileSatisfaction;
}

export enum SmileSatisfaction {
  NOT_SATISFIED = "NOT_SATISFIED",
  NOT_VERY = "NOT_VERY",
  SOMEWHAT = "SOMEWHAT",
  VERY = "VERY",
  EXTREMELY = "EXTREMELY",
}

export const smileSatisfactionOrdered = [
  SmileSatisfaction.NOT_SATISFIED,
  SmileSatisfaction.NOT_VERY,
  SmileSatisfaction.SOMEWHAT,
  SmileSatisfaction.VERY,
  SmileSatisfaction.EXTREMELY,
];

export function getSmileSatisfactionI18n(smileSatisfaction: SmileSatisfaction) {
  switch (smileSatisfaction) {
    case SmileSatisfaction.NOT_SATISFIED:
      return "Form.DentalInformation.Field.SmileSatisfaction.NotSatisfied";
    case SmileSatisfaction.NOT_VERY:
      return "Form.DentalInformation.Field.SmileSatisfaction.NotVery";
    case SmileSatisfaction.SOMEWHAT:
      return "Form.DentalInformation.Field.SmileSatisfaction.Somewhat";
    case SmileSatisfaction.VERY:
      return "Form.DentalInformation.Field.SmileSatisfaction.Very";
    case SmileSatisfaction.EXTREMELY:
      return "Form.DentalInformation.Field.SmileSatisfaction.Extremely";
  }
}
